module.exports = __webpack_public_path__ + "static/media/ribbonCV.fff50bbb.mp4";